import type { Module } from 'vuex'
import { shortUrlActions } from './actions'
import type { RootState } from '@/store/modules/types'

export interface ShortUrlState {
  shortUrls: any[]
  isFetchingShortUrls: boolean
}

export const initialShortUrlState = (): ShortUrlState => ({
  shortUrls: [],
  isFetchingShortUrls: false,
})

const shortUrlModule: Module<ShortUrlState, RootState> = {
  namespaced: true,
  state: initialShortUrlState,
  actions: shortUrlActions,
  mutations: {
    SET_SHORT_URLS(state: ShortUrlState, shortUrls: any[]) {
      state.shortUrls = shortUrls
    },
    SET_FETCHING_SHORT_URLS(state: ShortUrlState, isFetching: boolean) {
      state.isFetchingShortUrls = isFetching
    },
  },
}

export default shortUrlModule
